import script from "./CustomResourceApplyNew.vue?vue&type=script&setup=true&lang=ts"
export * from "./CustomResourceApplyNew.vue?vue&type=script&setup=true&lang=ts"

import "./CustomResourceApplyNew.vue?vue&type=style&index=0&id=1086fe70&lang=less&scope=true"

const __exports__ = script;

export default __exports__